import Region from '../../../constants/region';
import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import stages from '../stages';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [Region.UNC, Region.MMPA, Region.BONGARDS],
});

const demo = new Environment({
    name: stages.DEMO,
    regions: [Region.UNC, Region.MMPA, Region.BONGARDS],
});

const staging = new Environment({
    name: stages.STAGING,
    regions: [Region.UNC, Region.MMPA, Region.BONGARDS],
});

const local = new Environment({
    name: stages.LOCAL,
    regions: [Region.UNC, Region.MMPA, Region.BONGARDS],
});

const dev = new Environment({
    name: stages.DEV,
    regions: [Region.UNC, Region.MMPA, Region.BONGARDS],
});

const can_access_adhoc_reports = new MockSplit({
    name: 'can_access_adhoc_reports',
    environments: [local, dev, staging, demo, prod],
});

export default can_access_adhoc_reports;
